var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cluji-card',{attrs:{"title":"Fin d'année","subtitle":"Terminer l'année en cours"}},[_c('div',{staticClass:"text-center"},[_c('b-button',{staticClass:"disk-button p-0 m-2",attrs:{"variant":"danger"},on:{"click":_vm.triggerEndYear}},[_c('font-awesome-icon',{attrs:{"icon":"biohazard"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }